import $store from '@/store'
import { getUserInfo } from '@/utils/auth'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { EntityDefaultValue } from '@/class/model/sys/EntityDefaultValue'
import { loadJobDefaultValues, saveEntityDefaultValue } from '@/api/sysManage/baseConfig/defaultValueManage'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export class EntityDefaultValueUtil {
  // 实例集合
  static instanceMap = new Map()
  /**
   * constructor
   */
  constructor(branchId, view) {
    this._view = view
    this.branchId = branchId
    this.userId = getUserInfo().userId
    this.defaultValues = null
    // 海出Job默认值对象
    this.seaExportJob = new SeaExportJob()
    this.seaExportNames = this.seaExportJob.getPropertyNames()
    // 海进Job默认值对象
    this.seaImportJob = new SeaImportJob()
    this.seaImportNames = this.seaImportJob.getPropertyNames()
    // 铁出Job默认值对象
    this.railwayExportJob = new RailwayExportJob()
    this.railwayExportNames = this.railwayExportJob.getPropertyNames()
    // 铁进Job默认值对象
    this.railwayImportJob = new RailwayExportJob()
    // 空出Job默认值对象
    this.airExportJob = new AirExportJob()
    this.airExportNames = this.airExportJob.getPropertyNames()
    // 空进Job默认值对象
    this.airImportJob = new AirImportJob()
    this.airImportNames = this.airImportJob.getPropertyNames()
    // 综合物流Job默认值对象
    this.integratedJob = new IntegratedJob()
    this.integratedNames = this.integratedJob.getPropertyNames()
    // 箱型箱量默认值对象
    this.seaEQ = {}
    this.AirUld = {}
    this.cargoDoc = {}
  }
  static getInstance() {
    const branchId = $store.getters.currentOfficeId
    let instance = this.instanceMap.get(branchId)
    if (!instance) {
      instance = new EntityDefaultValueUtil(branchId)
      this.instanceMap.set(branchId, instance)
    }
    return instance
  }
  /**
   * 加载配置参数
   */
  async initEntityDefaultValue() {
    this.defaultValues = await loadJobDefaultValues({ branchId: this.branchId }).then(res => res.data)
    for (const item of this.defaultValues) {
      /* 兼容以前的默认值配置 */
      item.actualFieldCode = this.getActualFieldCode(item.entityCode, item.fieldCode)
      item.actualDefalutValue = this.getActualDefaultValue(item)
      /* 给对象赋默认值 */
      switch (item.entityCode) { // SE
        case 'Job':
          if (item.seDefaultValue) {
            this.seaExportJob.getData()[item.actualFieldCode] = this.getActualDefaultValue(item, item.seDefaultValue)
          } else {
            // CARGO-32940 航空公司中出现了船公司
            if (item.fieldCode === 'carrierId') {
              const carrier = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', item.actualDefalutValue)
              if (carrier && carrier.seaCmp && carrier.active) {
                this.seaExportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
              }
            } else {
              this.seaExportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
            }
          }
          break
        case 'SeaExportJob':
          this.seaExportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
          break
      }
      switch (item.entityCode) { // SI
        case 'Job':
          if (item.siDefaultValue) {
            this.seaImportJob.getData()[item.actualFieldCode] = this.getActualDefaultValue(item, item.siDefaultValue)
          } else {
            // CARGO-32940 航空公司中出现了船公司
            if (item.fieldCode === 'carrierId') {
              const carrier = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', item.actualDefalutValue)
              if (carrier && carrier.seaCmp && carrier.active) {
                this.seaImportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
              }
            } else {
              this.seaImportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
            }
          }
          break
        case 'SeaImportJob':
          this.seaImportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
          break
      }
      switch (item.entityCode) { // RE
        case 'Job':
          if (item.reDefaultValue) {
            this.railwayExportJob.getData()[item.actualFieldCode] = this.getActualDefaultValue(item, item.reDefaultValue)
          } else {
            this.railwayExportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
          }
          break
        case 'RailwayExportJob':
          this.railwayExportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
          break
      }
      switch (item.entityCode) { // RI
        case 'Job':
          if (item.riDefaultValue) {
            this.railwayImportJob.getData()[item.actualFieldCode] = this.getActualDefaultValue(item, item.riDefaultValue)
          } else {
            this.railwayImportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
          }
          break
        case 'RailwayExportJob':
          this.railwayImportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
          break
      }
      switch (item.entityCode) { // AE
        case 'Job':
          if (item.aeDefaultValue) {
            this.airExportJob.getData()[item.actualFieldCode] = this.getActualDefaultValue(item, item.aeDefaultValue)
          } else {
            // CARGO-32940 航空公司中出现了船公司
            if (item.fieldCode === 'carrierId') {
              const carrier = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', item.actualDefalutValue)
              if (carrier && carrier.airCmp && carrier.active) {
                this.airExportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
              }
            } else {
              this.airExportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
            }
          }
          break
        case 'AirExportJob':
          this.airExportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
          break
      }
      switch (item.entityCode) { // AI
        case 'Job':
          if (item.aiDefaultValue) {
            this.airImportJob.getData()[item.actualFieldCode] = this.getActualDefaultValue(item, item.aiDefaultValue)
          } else {
            // CARGO-32940 航空公司中出现了船公司
            if (item.fieldCode === 'carrierId') {
              const carrier = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', item.actualDefalutValue)
              if (carrier && carrier.airCmp && carrier.active) {
                this.airImportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
              }
            } else {
              this.airImportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
            }
          }
          break
        case 'AirImportJob':
          this.airImportJob.getData()[item.actualFieldCode] = item.actualDefalutValue
          break
      }
      if (item.entityCode === 'SeaEQ') {
        this.seaEQ[item.actualFieldCode] = item.actualDefalutValue
      }
      if (item.entityCode === 'CargoDoc') {
        this.cargoDoc[item.actualFieldCode] = item.actualDefalutValue
        if (item.actualDefalutValue.length > 0) {
          this.splitNotifyLine('aeHawbNotifyLine', item)
          this.splitNotifyLine('aeMawbNotifyLine', item)
          this.splitNotifyLine('aeFhawbNotifyLine', item)
        }
      }
      if (item.entityCode === 'AirUld') {
        this.AirUld[item.actualFieldCode] = item.actualDefalutValue
      }
    }
  }
  /**
   * Boolean类型去掉is前缀，名称不区分大小写
   */
  getActualFieldCode(entityCode, fieldCode) {
    if (fieldCode.startsWith('is')) {
      fieldCode = fieldCode.substr(2)
    }
    const lowerFieldCode = fieldCode.toLowerCase()
    // 匹配对应的属性名称
    switch (entityCode) {
      case 'Job':
      case 'SeaExportJob':
        fieldCode = this.seaExportNames.find(p => p.toLowerCase() === lowerFieldCode)
        break
      case 'SeaImportJob':
        fieldCode = this.seaImportNames.find(p => p.toLowerCase() === lowerFieldCode)
        break
      case 'AirExportJob':
        fieldCode = this.airExportNames.find(p => p.toLowerCase() === lowerFieldCode)
        break
      case 'AirImportJob':
        fieldCode = this.airImportNames.find(p => p.toLowerCase() === lowerFieldCode)
        break
      case 'RailwayExportJob':
        fieldCode = this.railwayExportNames.find(p => p.toLowerCase() === lowerFieldCode)
        break
      case 'CargoDoc':
        switch (fieldCode) {
          case 'AeHawbNotify':
            fieldCode = 'aeHawbNotifyLine'
            break
          case 'AeMawbNotify':
            fieldCode = 'aeMawbNotifyLine'
            break
          case 'AeFhawbNotify':
            fieldCode = 'aeFhawbNotifyLine'
            break
        }
        break
      case 'SeaEQ':
        switch (fieldCode) {
          case 'EQsize':
            fieldCode = 'eqSize'
            break
          case 'EQtype':
            fieldCode = 'eqType'
            break
        }
        break
      case 'AirUld':
        switch (fieldCode) {
          case 'ContainerType':
            fieldCode = 'containerType'
            break
          case 'ContainerCode':
            fieldCode = 'containerCode'
            break
        }
        break
      default:
        fieldCode = ''
        break
    }
    return fieldCode
  }
  /**
   * Boolen、Number类型的值转换
   */
  getActualDefaultValue(entity, defaultVal) {
    if (!defaultVal) {
      defaultVal = entity.defaultValue
    }
    switch (entity.valueType) {
      case 'boolean':
        defaultVal = Boolean(Number(defaultVal))
        break
      case 'number':
      case 'int':
        defaultVal = Number(defaultVal) || 0
        break
    }
    return defaultVal
  }
  /**
   * 获取实体默认值
   */
  getJobDefaultValueNewInstance(entityCode, job) {
    if (!this.defaultValues || this.defaultValues.length === 0) {
      return
    }
    switch (entityCode) {
      case 'SeaExportJob':
        Object.assign(job, this.seaExportJob.getData())
        break
      case 'SeaImportJob':
        Object.assign(job, this.seaImportJob.getData())
        break
      case 'AirExportJob':
        Object.assign(job, this.airExportJob.getData())
        break
      case 'AirImportJob':
        Object.assign(job, this.airImportJob.getData())
        break
      case 'RailwayExportJob':
        if (job.lob === 'RE') {
          Object.assign(job, this.railwayExportJob.getData())
        } else {
          Object.assign(job, this.railwayImportJob.getData())
        }
        break
    }
  }
  /**
   * 保存默认值
   */
  async saveEntityDefaultValue(entityCodes, job) {
    if (!entityCodes || !job) {
      return
    }
    if (!this.defaultValues) {
      await this.initEntityDefaultValue()
    }
    const oldList = []
    const newList = []
    for (const entity of this.defaultValues) {
      if (entityCodes.includes(entity.entityCode)) {
        if (entity.branchId === this.branchId && entity.userId === this.userId) {
          oldList.push(entity)
        }
        // 新增当前用户默认值
        newList.push(this.addUserDefaultValue(job, entity))
      }
    }
    if (oldList.length > 0 || newList.length > 0) {
      const oldUuidList = Array.from(oldList, p => p.uuid)
      await saveEntityDefaultValue({ oldUuidList, newList })
      await this.initEntityDefaultValue()
    }
  }
  /**
   * 新增用户默认值
   */
  addUserDefaultValue(job, entity) {
    const newEntity = new EntityDefaultValue().fillDefaultValue().getData()
    newEntity.userId = this.userId
    newEntity.branchId = this.branchId
    newEntity.entityCode = entity.entityCode
    newEntity.entityName = entity.entityName
    newEntity.fieldCode = entity.fieldCode
    newEntity.fieldName = entity.fieldName
    newEntity.valueType = entity.valueType
    newEntity.defaultValue = entity.defaultValue
    newEntity.seDefaultValue = entity.seDefaultValue
    newEntity.siDefaultValue = entity.siDefaultValue
    newEntity.aeDefaultValue = entity.aeDefaultValue
    newEntity.aiDefaultValue = entity.aiDefaultValue
    newEntity.reDefaultValue = entity.reDefaultValue
    newEntity.riDefaultValue = entity.riDefaultValue
    const defaultVal = this.getDefaultValue(entity, job[entity.actualFieldCode])
    if (entity.entityCode === 'Job') {
      switch (job.lob) {
        case 'SE':
          newEntity.seDefaultValue = defaultVal
          break
        case 'SI':
          newEntity.siDefaultValue = defaultVal
          break
        case 'AE':
          newEntity.aeDefaultValue = defaultVal
          break
        case 'AI':
          newEntity.aiDefaultValue = defaultVal
          break
        case 'RE':
          newEntity.reDefaultValue = defaultVal
          break
        case 'RI':
          newEntity.riDefaultValue = defaultVal
          break
        default:
          newEntity.defaultValue = defaultVal
          break
      }
    } else if (entity.entityCode === 'CargoDoc') {
      switch (job.lob) {
        case 'AE':
          if (job.airCargoDoc && this._view) {
            let hawb = {}
            let mawb = {}
            let hawb2 = {}
            if (job.virtualHBL && this._view.$refs.tabSubBill) {
              hawb2 = this._view.$refs.tabSubBill.form
            }
            for (const item of job.airCargoDoc) {
              if (item.docType === 'HAWB') {
                hawb = item
              } else if (item.docType === 'MAWB') {
                mawb = item
              } else if (!hawb2 && item.docType === 'HAWB2') {
                hawb2 = item
              }
            }
            switch (entity.fieldCode) {
              case 'AeHawbNotify':
                if (hawb && this._view.activeTabName === 'tabHAWB') {
                  newEntity.defaultValue = this.mergeNotifyLine(hawb)
                }
                break
              case 'AeMawbNotify':
                if (mawb && this._view.activeTabName === 'tabMAWB') {
                  newEntity.defaultValue = this.mergeNotifyLine(mawb)
                }
                break
              case 'AeFhawbNotify':
                if (hawb2 && this._view.activeTabName === 'tabSubBill') {
                  newEntity.defaultValue = this.mergeNotifyLine(hawb2)
                }
                break
            }
          }
          break
      }
    } else {
      newEntity.defaultValue = defaultVal
    }
    return newEntity
  }
  /**
   * 默认值获取
   */
  getDefaultValue(entity, value) {
    if (entity.valueType === 'boolean') {
      return value ? '1' : '0'
    } else if (entity.valueType === 'number' || entity.valueType === 'int') {
      return String(value)
    }
    return value
  }
  splitNotifyLine(cloumn, item) {
    if (item.actualFieldCode === cloumn) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = item.actualDefalutValue.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.cargoDoc[cloumn + i] = item.actualDefalutValue.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.cargoDoc[cloumn + i] = item.actualDefalutValue.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.cargoDoc[cloumn + i] = ''
      }
    }
  }
  mergeNotifyLine(val) {
    let result = ''
    for (let i = 1; i < 7; ++i) {
      result += val['notifyLine' + i] || ''
      result += '\n'
    }
    return result + (val['notifyLine7'] || '')
  }
}
